import React, { useEffect, useState } from 'react';
import { Card, DatePicker, Tabs, Tooltip, Drawer } from "antd";
import { MDBCol, MDBRow } from "mdbreact";
import { Text } from "react-font";
import { Button, Dialog, SearchInput } from "evergreen-ui";
import { Table } from 'antd';
import Firebase from "../../Firebase/Firebase";
import { TableExport } from "tableexport";
import FireFetch from "../../Firebase/FireFetch";
import { useListVals } from "../../Firebase/databaseHooks";
import AddInteraction from "../../Modals/Interaction/AddInteraction";
import ViewInteraction from "../../Modals/Interaction/ViewInteraction";
import { writeFile, utils } from "xlsx";
import { getDatabase, ref } from "firebase/database";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import EditInteraction from "../../Modals/Interaction/EditInteraction";
import { useAuth } from "../../AuthContext/AuthContext";
import TableActionMenu from "../../Common/TableActionMenu";
import {
	getOrganizationName,
	getInteractionSubmitterId,
	getInteractionTypeLabel,
	getUserName,
} from "../../Firebase/dataCompat";

const moment = require("moment");
const { RangePicker } = DatePicker;
const columns = [
	{
		title: 'Type',
		dataIndex: 'type',
		key: 'type',
		sorter: (a, b) => a.type && a.type.localeCompare(b.type),
	},
	{
		title: 'Lesson',
		dataIndex: 'lesson',
		key: 'lesson',
		sorter: (a, b) => a.lesson && a.lesson.localeCompare(b.lesson),
	},
	{
		title: 'Community',
		dataIndex: 'community',
		key: 'community',
		sorter: (a, b) => a.community && a.community.localeCompare(b.community),
	},
	{
		title: 'Worker',
		dataIndex: 'worker',
		key: 'worker',
		sorter: (a, b) => a.worker && a.worker.localeCompare(b.worker),
	},
	{
		title: 'Interaction',
		dataIndex: 'interaction',
		key: 'interaction',
		render: (text) => (
			<span className="interaction-export-wrapper">
				<Tooltip title={<span style={{ color: 'black' }}>{text}</span>} overlayInnerStyle={{ backgroundColor: 'white' }}>
					<a>{text?.length > 20 ? `${text.substring(0, 20)}...` : text}</a>
				</Tooltip>
				<span className="full-text-for-export" style={{ display: 'none' }}>{text}</span>
			</span>
		),
		sorter: (a, b) => (a.interaction || "").localeCompare(b.interaction || ""),
		responsive: ["sm"]
	},
	{
		title: 'Notes',
		dataIndex: 'notes',
		key: 'notes',
		render: (text) => (
			<span className="interaction-export-wrapper">
				<Tooltip title={<span style={{ color: 'black' }}>{text}</span>} overlayInnerStyle={{ backgroundColor: 'white' }}>
					<a>{text?.length > 20 ? `${text.substring(0, 20)}...` : text}</a>
				</Tooltip>
				<span className="full-text-for-export" style={{ display: 'none' }}>{text}</span>
			</span>
		),
		sorter: (a, b) => (a.interaction || "").localeCompare(b.interaction || ""),
		responsive: ["sm"]
	},
	{
		title: 'Commitement',
		dataIndex: 'commitments',
		key: 'commitments',
		render: (text) => (
			<span className="interaction-export-wrapper">
				<Tooltip title={<span style={{ color: 'black' }}>{text}</span>} overlayInnerStyle={{ backgroundColor: 'white' }}>
					<a>{text?.length > 20 ? `${text.substring(0, 20)}...` : text}</a>
				</Tooltip>
				<span className="full-text-for-export" style={{ display: 'none' }}>{text}</span>
			</span>
		),
		responsive: ["sm"],
		sorter: (a, b) => (a.interaction || "").localeCompare(b.interaction || ""),
	},
	{
		title: 'Organization',
		dataIndex: 'organisation',
		key: 'organisation',
		responsive: ["sm"],
		sorter: (a, b) => a.organisation && a.organisation.localeCompare(b.organisation),
	},
	{
		title: 'Time',
		key: 'time',
		dataIndex: 'time',
		responsive: ["sm"],
		sorter: (a, b) => moment(a.time, "DD/MMM/YYYY HH:MM").diff(moment(b.time, "DD/MMM/YYYY HH:MM"))

	},
	{
		title: 'Action',
		key: 'action',
		dataIndex: 'action',

	},
];

const { TabPane } = Tabs;
var db = getDatabase(Firebase);
var auth = getAuth(Firebase);
const Interactions = (props) => {
	const { canAccessModule } = useAuth();
	const canCreateInteraction = canAccessModule("INTERACTIONS", "create");
	const canUpdateInteraction = canAccessModule("INTERACTIONS", "update");
	const canDeleteInteraction = canAccessModule("INTERACTIONS", "delete");

	const [searchValue, setSearchValue] = useState();
	const [dataMyArray, setDataMyArray] = useState([]);
	const [dataStaffArray, setDataStaffArray] = useState([])
	const [checkedData, setCheckedData] = useState(false);
	const [interArray, loading] = useListVals(ref(db, "talmidsdb/interactions"));
	const [organizationArray] = useListVals(ref(db, "talmidsdb/organisations"));
	const [communityArray] = useListVals(ref(db, "talmidsdb/communities"));
	const [userArray] = useListVals(ref(db, "talmidsdb/users"));
	const [lessonArray] = useListVals(ref(db, "talmidsdb/lessons"));
	const [viewModal, setViewModal] = useState(false);
	const [editModal, setEditModal] = useState(false);
	const [selectedInter, setSelectedInter] = useState(null);
	const [createModal, setCreateModal] = useState(false);
	const [myInteractions, setMyInteractions] = useState([]);
	const [staffInteractions, setStaffInteractions] = useState([]);
	const [showPicker, setShowPicker] = useState(false);
	const [period, setPeriod] = useState([]);

	const callback = (data) => {
		setCheckedData(data);
	}
	useEffect(() => {
		onAuthStateChanged(auth, function (user) {
			if (user) {
				const currentUserRecord = userArray.find(x =>
					x.id === user.uid ||
					x.userID === user.uid ||
					x.uid === user.uid ||
					(user.email && user.email === x.email)
				);
				const UID = user.uid;
				const userRole = currentUserRecord?.userRole;
				if (interArray) {
					var tempArray = [];
					interArray.map((item, index) => {
						console.log('lessons', lessonArray);
						const ownerId = getInteractionSubmitterId(item);
						const interactionId = item.interactionID || item.id;
						tempArray.push({
							key: interactionId || index,
							ownerId,
							interactionID: interactionId,
							interaction: item.interactions || item.interaction || item.description,
							notes: item.notes,
							commitments: item.commitments,
							lessonCode: lessonArray?.find(x => x.id === item.lessonId || x.id === item.lessonID)?.lessonCode,
							lesson: lessonArray?.find(x => x.id === item.lessonId || x.id === item.lessonID)?.lessonName,
							community: communityArray.find(x => x.id === item.communityID || x.communityID === item.communityID)?.name,
							workerID: ownerId,
							worker: getUserName(userArray, ownerId, "Unknown user"),
							organisation: getOrganizationName(
								organizationArray,
								item.organisationID || item.orgID,
								"Unknown organization"
							),
							type: getInteractionTypeLabel(item),
							time: moment(item.dateTime || item.date || item.timeStamp || item.createdAt).format("DD/MMM/YYYY HH:mm"),
							action: (
								<TableActionMenu
									items={[
										{
											key: "view",
											label: "View",
											onClick: () => {
												console.log(item);
												setSelectedInter(item);
												setViewModal(true);
											},
										},
										canUpdateInteraction && {
											key: "edit",
											label: "Edit",
											onClick: () => {
												setSelectedInter(item);
												setEditModal(true);
											},
										},
										canDeleteInteraction && {
											key: "delete",
											label: "Delete",
											danger: true,
											onClick: () => {
												if (!canDeleteInteraction) {
													alert("You do not have permission to delete interactions.");
													return;
												}

												if (confirm("Are you sure you want to delete Interaction?")) {
													FireFetch.DeleteFromDB("interactions", interactionId).then((message) => {
														if (message === "success") {
															FireFetch.addLog("interactions", interactionId, "Delete");
															alert("Interaction deleted");
														} else {
															alert("Unable to delete");
														}
													}).catch(() => {
														alert("Unable to delete");
													});
												}
											},
										},
									]}
								/>
							)
						});
					});

					var myFiltered = tempArray.filter(x => x.ownerId === UID);
					setMyInteractions([...myFiltered]);
					setDataMyArray([...myFiltered]);


					if (userRole === "SuperUser") {
						setStaffInteractions([...tempArray]);
						setDataStaffArray([...tempArray]);
					} else {
						var mySupervised = userArray.filter(x => x.supervisor === UID);
						var superviseeArray = [];
						mySupervised.map(supervised => {
							var filterArray = tempArray.filter(x => x.ownerId === (supervised.userID || supervised.id));
							superviseeArray = superviseeArray.concat(filterArray);
						});
						setStaffInteractions([...superviseeArray]);
						setDataStaffArray([...superviseeArray]);
					}

				}

			} else {
				window.location.href = "/login";
			}
		});


	}, [communityArray, interArray, lessonArray, organizationArray, userArray, canUpdateInteraction, canDeleteInteraction]);


	const handleSearch = searchText => {
		searchText = String(searchText || "").toLowerCase();
		const filteredStaffEvents = dataStaffArray.filter(({ interaction, lesson, community, organisation, type, worker, time }) => {
			worker = worker && worker.toLowerCase();
			community = community && community.toLowerCase();
			organisation = organisation && organisation.toLowerCase();
			time = time?.toLowerCase();
			interaction = interaction && interaction.toLowerCase();
			lesson = lesson && lesson.toLowerCase();
			type = type && type.toLowerCase();
			return (interaction && interaction.includes(searchText)) || (lesson && lesson.includes(searchText)) ||
				(organisation && organisation.includes(searchText)) ||
				(community && community.includes(searchText)) || (type && type.includes(searchText)) ||
				(worker && worker.includes(searchText)) || time?.includes(searchText);

		});
		setStaffInteractions([...filteredStaffEvents]);

		const filteredMyEvents = dataMyArray.filter(({ lesson, community, organisation, type, worker }) => {
			worker = worker && worker.toLowerCase();
			community = community && community.toLowerCase();
			organisation = organisation && organisation.toLowerCase();
			lesson = lesson && lesson.toLowerCase();
			type = type && type.toLowerCase();
			return (lesson && lesson.includes(searchText)) || (organisation && organisation.includes(searchText)) ||
				(community && community.includes(searchText)) || (type && type.includes(searchText)) || (worker && worker.includes(searchText));

		});
		setMyInteractions([...filteredMyEvents]);
	};

	// const exportXL = (title, tableID) => {
	// 	var table = TableExport(document.getElementById(tableID), {
	// 		filename: title,
	// 		exportButtons: false,
	// 		sheetname: title,
	// 	});
	// 	var exportData = table.getExportData();
	// 	console.log(exportData);
	// 	var csv = exportData[tableID].csv;
	// 	table.export2file(csv.data, csv.mimeType, csv.filename, csv.fileExtension, csv.merges, csv.RTL, csv.sheetname);
	// }

	const exportXL = (title, tableID) => {
		const dataSource = tableID === 'myDataTable' ? myInteractions : staffInteractions;
		const exportData = dataSource.map(item => ({
			...item,
			interaction: item.interaction,
			commitments: item.commitments,
			notes: item.notes
		}));
		const ws = utils.json_to_sheet(exportData);
		const wb = utils.book_new();
		utils.book_append_sheet(wb, ws, "Sheet1");
		writeFile(wb, `${title}.xlsx`);
	}

	const downloadExcel = (data) => {
		console.log('report', data);
		const processedData = data.map(({ type, lesson, lessonCode, community, worker, organisation, commitment, notes, interaction, time }) => ({
			Type: type,
			Lesson: lesson,
			LessonCode: lessonCode,
			Community: community,
			Worker: worker,
			Organisation: organisation,
			Commitment: commitment,
			Notes: notes,
			Interaction: interaction,
			Time: time,
		}));

		const worksheet = utils.json_to_sheet(processedData);
		const workbook = utils.book_new();
		utils.book_append_sheet(workbook, worksheet, "Sheet1");
		writeFile(workbook, "Staff Interactions.xlsx");
	};

	function onDateChange(date, dateString) {
		setPeriod(dateString);
	}

	function filterPeriod() {

		var startTime = moment(period[0], 'YYYY-MM-DD');
		var endTime = moment(period[1], 'YYYY-MM-DD');

		var withinPeriodArray = [];
		staffInteractions.map((inter) => {
			var interTime = moment(inter.time, 'DD/MMM/YYYY HH:MM');
			if (moment(interTime).isBetween(startTime, endTime)) {

				delete inter.action;
				delete inter.key;
				withinPeriodArray.push(inter);
			}
		})
		downloadExcel(withinPeriodArray);
		setShowPicker(false)
	}

	return (
		<div className="font-Nunito">
			<Drawer
				title="View Interaction"
				width={800}
				maskClosable
				className="font-Nunito"
				placement="right"
				visible={viewModal}
				onClose={() => { setViewModal(false) }}
			>
				<ViewInteraction modal={setViewModal} interaction={selectedInter} />
			</Drawer>
			<Dialog
				isShown={editModal}
				title="Edit Interaction"
				onCloseComplete={() => { setEditModal(false) }}
				hasFooter={false}
			>
				<EditInteraction modal={setEditModal} interaction={selectedInter} />
			</Dialog>
			<Dialog
				isShown={showPicker}
				title="Select Period"
				onCloseComplete={() => { setShowPicker(false) }}
				onConfirm={() => {
					filterPeriod();
				}}
			>
				<RangePicker onChange={onDateChange} />
			</Dialog>
			<Dialog
				isShown={createModal}
				title="Create New Interaction"
				onCloseComplete={() => { setCreateModal(false) }}
				confirmLabel="Create"
				hasFooter={false}
				shouldCloseOnOverlayClick={false}
			>
				<AddInteraction modal={setCreateModal} />
			</Dialog>
			<div className="d-flex justify-content-center align-items-center pt-4 mt-4">
				<MDBRow className="w-100">
					<MDBCol md={12}>
						<Card className="w-100">
							<MDBRow>
								<MDBCol md={12}>
									<div className="text-left">
										<div className="d-flex flex-row justify-content-between">
											<div className="d-inline">
												<h5 className="font-weight-bold" style={{ color: '#51195D' }}>
													<Text family='Nunito'>
														Interactions
													</Text>
												</h5>
											</div>
											<div className="d-flex flex-row">
												<SearchInput placeholder="Filter through lessons or communities or organisations" onChange={e => handleSearch(e.target.value)} value={searchValue} />
												{canCreateInteraction && (
													<Button appearance="primary" className="mx-2" onClick={() => { setCreateModal(true) }}>
														New Interaction
													</Button>
												)}
											</div>
										</div>
									</div>
								</MDBCol>
							</MDBRow>
						</Card>
						<Card>
							<Tabs defaultActiveKey="1" type="card" size={"normal"}>
								<TabPane tab="My Interactions" key="1">
									<div>
										<div style={{ marginBottom: 10 }} className="float-right">
											<Button intent="primary"
												onClick={() => {
													exportXL("My Interactions", "myDataTable");
												}}
												appearance="primary">
												Print
											</Button>
										</div>
										<Table className="custom-table" id="myDataTable" loading={loading}
											pagination={{ defaultPageSize: 100, showSizeChanger: true, pageSizeOptions: ['100', '200', '300'] }}
											style={{ overflow: "auto" }}
											columns={columns} dataSource={myInteractions} />
									</div>
								</TabPane>
								<TabPane tab="My Team's Interactions" key="2">
									<div>
										<div style={{ marginBottom: 10 }} className="float-right">
											<Button intent="primary"
												onClick={() => {
													setShowPicker(true);
												}}
												appearance="primary">
												Print
											</Button>
										</div>
										<Table
											className="custom-table"
											id="staffDataTable"
											loading={loading}
											pagination={{
												defaultPageSize: 100,
												showSizeChanger: true,
												pageSizeOptions: ['100', '200', '300']
											}}
											style={{ overflow: "auto" }}
											columns={columns}
											dataSource={staffInteractions}
											rowKey="interactionID"
										/>
									</div>
								</TabPane>
							</Tabs>
						</Card>
					</MDBCol>
				</MDBRow>
			</div>
		</div>
	)

}

export default Interactions;
